import { Button as MuiButton } from "@material-ui/core";

export default function Button({variant = "contained", color = "primary",  disabled = false,...props }) {
  return <MuiButton variant={variant} color={color} disabled={disabled}  {...props} />;
}
